import { NsColumn } from '@britishgasenergy/react-nucleus';
import type { NsColumnProps } from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn/NsColumn';

import { NsPanel } from 'components/common/ns-panel/NsPanel';

import type { ScreenParts } from 'components/app/routes/app-routes-revamp';

export const ScreenTemplate = (props: ScreenParts) => {
  const { Content, LeftSidebar, RightSidebar, Header, Skyline, Footer } = props;
  const hasRightSidebar = !!RightSidebar;
  const hasLeftSidebar = !!LeftSidebar;
  let col: NsColumnProps['hockeypitch'] = '1';

  switch (true) {
    case hasLeftSidebar && !hasRightSidebar:
      col = '1:2';
      break;
    case !hasLeftSidebar && hasRightSidebar:
      col = '2:1';
      break;
    default:
      col = '1';
  }

  return (
    <>
      {Skyline && <Skyline />}
      {Header && (
        <NsPanel>
          <Header />
        </NsPanel>
      )}

      <NsPanel decoration="cyan-light" inset>
        <NsColumn hockeypitch={col}>
          {hasLeftSidebar && <LeftSidebar />}
          {Content && <Content />}
          {hasRightSidebar && <RightSidebar />}
        </NsColumn>
      </NsPanel>

      {Footer && <Footer />}
    </>
  );
};
